export default {
  init() {
    // JavaScript to be fired on the home page
    $(document).ready(function() {
      if ($(window).width() >= 960) {
        $('.menu__background').each(function() {
          $(this).on('mouseenter mouseleave', function() {
            $('.menu__background').not(this).toggleClass('darken').fadeIn(400);
            $('.menu__backgroud.darken .overlay').fadeToggle(600);
          });
        });
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js